"use client";

import { ReactNode } from "react";
import { useTranslations } from "next-intl";
import { EventData } from "@types";
import PasswordForm from "@components/passwordForm";
import { EventVenuePasswordProvider } from "../context";
import { useEventVenuePasswordValidation } from "../hooks/useEventVenuePasswordValidation";

interface Props {
  event: EventData;
  children: ReactNode;
}

function GatedShowings({ event, children }: Props) {
  const t = useTranslations("EventPage.eventvenuepassword");
  const { password, submitPassword, passwordStatus } =
    useEventVenuePasswordValidation({
      eventId: event.legacy.e_id,
      eventVenueId: event.legacy.ev_id,
    });

  if (passwordStatus !== "complete") {
    return (
      <PasswordForm
        title={t("heading")}
        description={
          event.access?.password.description?.trim() || t("description")
        }
        status={passwordStatus}
        defaultValue={password}
        onSubmit={submitPassword}
        name="eventvenue_password"
        className={event.subdescription ? "mt-10" : "mt-4"}
      />
    );
  }

  return (
    <EventVenuePasswordProvider value={password}>
      {children}
    </EventVenuePasswordProvider>
  );
}

/**
 * Gates the showings behind the event venue password, when the event has one.
 * Showing level passwords are still handled separately by the area picker.
 */
export default function EventVenuePasswordGate({ event, children }: Props) {
  if (!event.access?.password.required) return <>{children}</>;

  return <GatedShowings event={event}>{children}</GatedShowings>;
}
